import { useState } from 'react';
import { ImageThumbnail, ImageThumbnailContainer } from 'pages/Representatives/components/ImageThumbnail';
import { useImageLoader } from 'pages/Representatives/features/AddRepresentatives/hooks/useImageLoader';
import { EditProfileCustomSkeleton, EditProfileDragContainer, EditProfileNumberBox } from '../../../EditProfile.styles';
import { HideIcon, UserIcon, Move, PencilIcon } from '@room-match/shared-ui-components';
import { Checkbox, IconButton } from '@material-ui/core';
import { EttachedHiddenType } from 'shared/enums/EAttachedHiddenType';
import { useEditProfileDndControls } from '../../../hooks/useEditProfileDndControls';
import { EditProfileMediaCheckBoxContainer } from '../../EditProfileMedia/EditProfileMedia.styles';

type EditProfileMediaDocumentsImageItemProps = {
  type?: EttachedHiddenType;
  image: {
    url: string;
    file_name?: string;
    primary: boolean;
    alt?: string;
    id: string;
  };
  index?: number;
  onEditorClick?: VoidFunction;
  onHideClick?: VoidFunction;
  onViewClick?: VoidFunction;
};

export const EditProfileMediaDocumentsImageItem = ({
  type = EttachedHiddenType.ATTACHED,
  image,
  index,
  onEditorClick,
  onHideClick,
  onViewClick,
}: EditProfileMediaDocumentsImageItemProps) => {
  const { attributes, listeners, style, setNodeRef, onMobile } = useEditProfileDndControls(image.id);
  const [isHovered, setIsHovered] = useState(false);
  const isOptmisicallyUpdating = image?.file_name?.includes('skeleton-optimistic-updating-list');
  const avatar = image?.url || '';

  const { src, loading } = useImageLoader(avatar);

  const sortAbleProps =
    image.primary || isOptmisicallyUpdating
      ? {}
      : {
          container: {
            ref: setNodeRef,
          },
          item: {
            ...attributes,
            ...listeners,
          },
        };

  return (
    <ImageThumbnailContainer
      {...sortAbleProps.container}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...sortAbleProps.container}
      style={{ ...style }}
      onClick={(e) => {
        e.stopPropagation();
        if (onViewClick) onViewClick();
      }}
    >
      {loading || isOptmisicallyUpdating ? (
        <EditProfileCustomSkeleton variant="rect" width={'100%'} height={'100%'} />
      ) : null}
      <EditProfileNumberBox style={type === EttachedHiddenType.HIDDEN ? { background: 'unset' } : undefined}>
        {type === EttachedHiddenType.ATTACHED ? (
          image?.primary ? (
            <UserIcon fill="white" />
          ) : isHovered && !isOptmisicallyUpdating ? (
            <IconButton style={{ padding: 0 }}>
              <HideIcon
                onClick={(e) => {
                  e.stopPropagation();
                  if (onHideClick) onHideClick();
                }}
              />
            </IconButton>
          ) : (
            index
          )
        ) : (
          <EditProfileMediaCheckBoxContainer
            onClick={(e) => {
              e.stopPropagation();
              if (onHideClick) onHideClick();
            }}
          >
            <Checkbox checked={false} />
          </EditProfileMediaCheckBoxContainer>
        )}
      </EditProfileNumberBox>
      {!image?.primary &&
      ((isHovered && type === EttachedHiddenType.ATTACHED && !isOptmisicallyUpdating) || onMobile) ? (
        <EditProfileDragContainer {...sortAbleProps.item}>
          <Move viewBox="0 0 16 16" />
        </EditProfileDragContainer>
      ) : null}
      {(isHovered && !isOptmisicallyUpdating) || onMobile ? (
        <EditProfileNumberBox style={{ inset: 'unset', bottom: 5, left: 5 }}>
          <PencilIcon
            htmlColor="white"
            onClick={(e) => {
              e.stopPropagation();
              if (onEditorClick) onEditorClick();
            }}
          />
        </EditProfileNumberBox>
      ) : null}
      <ImageThumbnail style={{ display: loading || isOptmisicallyUpdating ? 'none' : 'block' }} src={src} />
    </ImageThumbnailContainer>
  );
};
